<template>
  <div class="container site-config-wrapper">
    <div v-if="isInitialLoading" class="site-config-loading-overlay">
      <div class="text-center">
        <div class="spinner-border text-light mb-2" role="status" aria-hidden="true"></div>
        <div class="text-light">Loading site configuration...</div>
      </div>
    </div>
    <div :class="{'site-config-disabled': isInitialLoading}">
    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12 mb-2 text-right">
                <button class="btn btn-primary" :disabled="!isPageReady" @click.prevent="saveCollection">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Thickness</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <Thickness @updateThickness="updateThickness"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Dimensions</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <Dimensions @updateDimensions="updateDimensions"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Popular collections</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">

            <div class="row">
              <div class="col-12 mb-2">
                <CollectionsList spot="1" :selectedValue="collectionSpots.spot_1 && collectionSpots.spot_1.value" @updateCollectionSpot="updateCollectionSpot"/>
              </div>
              <div class="col-12 mb-2">
                <CollectionsList spot="2" :selectedValue="collectionSpots.spot_2 && collectionSpots.spot_2.value" @updateCollectionSpot="updateCollectionSpot"/>
              </div>
              <div class="col-12 mb-2">
                <CollectionsList spot="3" :selectedValue="collectionSpots.spot_3 && collectionSpots.spot_3.value" @updateCollectionSpot="updateCollectionSpot"/>
              </div>
              <div class="col-12 mb-2">
                <CollectionsList spot="4" :selectedValue="collectionSpots.spot_4 && collectionSpots.spot_4.value" @updateCollectionSpot="updateCollectionSpot"/>
              </div>
              <div class="col-12 mb-2">
                <CollectionsList spot="5" :selectedValue="collectionSpots.spot_5 && collectionSpots.spot_5.value" @updateCollectionSpot="updateCollectionSpot"/>
              </div>
              <div class="col-12 mb-2">
                <CollectionsList spot="6" :selectedValue="collectionSpots.spot_6 && collectionSpots.spot_6.value" @updateCollectionSpot="updateCollectionSpot"/>
              </div>
              <!--
              <div class="col-12 mb-2">
                <CollectionsList spot="7"/>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>


      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">What's New</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">

            <div class="row">
              <div class="col-12 mb-2">
                <CollectionsList spot="8" :selectedValue="collectionSpots.spot_8 && collectionSpots.spot_8.value" @updateCollectionSpot="updateCollectionSpot"/>
              </div>
              <div class="col-12 mb-2">
                <CollectionsList spot="9" :selectedValue="collectionSpots.spot_9 && collectionSpots.spot_9.value" @updateCollectionSpot="updateCollectionSpot"/>
              </div>
              <div class="col-12 mb-2">
                <CollectionsList spot="10" :selectedValue="collectionSpots.spot_10 && collectionSpots.spot_10.value" @updateCollectionSpot="updateCollectionSpot"/>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Popular Value Line</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <CollectionsListPopular @updatePopular="updatePopular"/>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Profile Type</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <ProfileType @updateProfileType="updateProfileType"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Color Family</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <ColorFamily @updateColorFamily="updateColorFamily"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Style</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <Style @updateStyle="updateStyle"/>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Finish</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <Finish @updateFinish="updateFinish"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-8">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Frame Types</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <FrameTypes @updateFrameType="updateFrameType"/>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-4">
        <div class="card collapsed-card">
          <div class="card-header">
            <h3 class="card-title">Discount Labels</h3>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus fa-lg"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <DiscountList @updateDiscount="updateDiscount"/>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-4 mb-2 ">
                <button class="btn btn-primary" :disabled="isInitialLoading" @click="goToPage({'name':'Policys'})">Policy & Terms</button>
              </div>
              <div class="col-4 mb-2 ">
                <button class="btn btn-primary" :disabled="isInitialLoading" @click="goToPage({'name':'WhoWeAre'})">Who We Are</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12 mb-2 text-right">
                <button class="btn btn-primary" :disabled="!isPageReady" @click.prevent="saveCollection">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import CollectionsList from "@/components/Admin/CollectionsList.vue";
import DiscountList from "@/components/Admin/DiscountList.vue";
import ProfileType from "@/components/Admin/ProfileType.vue";
import ColorFamily from "@/components/Admin/ColorFamily.vue";
import Thickness from "@/components/Admin/Thickness.vue";
import Dimensions from "@/components/Admin/Dimensions.vue";
import Style from "@/components/Admin/Style.vue";
import Finish from "@/components/Admin/Finish.vue";
import FrameTypes from "@/components/Admin/FrameTypes.vue";
import {mapGetters} from "vuex";
import {useToast} from "vue-toastification";
import CollectionsListPopular from "@/components/Admin/CollectionsListPopular.vue";


export default {
  name: "SiteConfig",
  setup() {
    // Get toast interface

    const toast = useToast();
    return {toast};
  },
  data() {
    return {
      loader: "dots",
      color: "#00ab00",
      bgColor: "#4b4b4b",
      collectionList: [],
      discountArr: [],
      profileTypeArr: [],
      colorFamilyArr: [],
      thicknessArr: [],
      dimensionsArr: [],
      styleArr: [],
      finishArr: [],
      frametypeArr: [],
      collectionPopular: [],
      collectionSpots: {},
      popularCollectionSettingId: null,
      isInitialLoading: true,
      sectionReady: {
        discount: false,
        profileType: false,
        colorFamily: false,
        thickness: false,
        dimensions: false,
        style: false,
        finish: false,
        frameType: false,
        popularValueLine: false
      }
    };
  },
  components: {
    CollectionsList,
    DiscountList,
    ProfileType,
    ColorFamily,
    Thickness,
    Dimensions,
    Style,
    Finish,
    FrameTypes,
    CollectionsListPopular
  },
  computed: {
    ...mapGetters({
      'collectionData': 'product/getCollectionData',
      'settingsData': 'product/getSettingsData',
    }),
    isPageReady() {
      return !this.isInitialLoading && Object.values(this.sectionReady).every(Boolean);
    }

  },
  methods: {
    goToPage(page) {
      this.$router.push(page);
    },
    updateFinish(data) {
      this.finishArr = data
      this.sectionReady.finish = true;
    },
    updateFrameType(data) {
      this.frametypeArr = data
      this.sectionReady.frameType = true;
    },
    updateStyle(data) {
      this.styleArr = data
      this.sectionReady.style = true;
    },
    updateColorFamily(data) {
      this.colorFamilyArr = data
      this.sectionReady.colorFamily = true;
    },
    updateThickness(data) {
      this.thicknessArr = data
      this.sectionReady.thickness = true;
    },
    updateDimensions(data) {
      this.dimensionsArr = data
      this.sectionReady.dimensions = true;
    },
    updateProfileType(proData) {
      this.profileTypeArr = proData
      this.sectionReady.profileType = true;
    },
    updateDiscount(disData) {
      this.discountArr = disData
      this.sectionReady.discount = true;
    },
    updatePopular(data) {
      this.collectionPopular = data
      this.sectionReady.popularValueLine = true;
    },
    updateCollectionSpot(data) {
      this.collectionSpots = {
        ...this.collectionSpots,
        [data.spotKey]: {
          name: data.name,
          value: data.value
        }
      };
    },
    hasData(data) {
      if (!data) {
        return false;
      }
      if (Array.isArray(data)) {
        return data.length > 0;
      }
      return Object.keys(data).length > 0;
    },
    getCollectionPayload() {
      const payload = {};
      for (let index = 1; index <= 10; index++) {
        const spotKey = `spot_${index}`;
        const currentValue = this.collectionSpots[spotKey] && this.collectionSpots[spotKey].value !== undefined
          ? this.collectionSpots[spotKey].value
          : "";
        const selectedCollection = this.collectionData.find((collection) => String(collection.id) === String(currentValue));
        payload[spotKey] = {
          name: selectedCollection ? selectedCollection.name : "",
          value: currentValue
        };
      }
      return payload;
    },
    async saveCollection() {
      if (!this.isPageReady) {
        this.toast.warning("Please wait until settings finish loading.");
        return;
      }
      let loader = this.$loading.show({
        color: this.color,
        backgroundColor: this.bgColor,
        loader: this.loader,
        opacity: 0.3,
      });
      const failedSections = [];

      try {
        if (!this.popularCollectionSettingId) {
          throw new Error("popular_collections setting was not loaded");
        }
        const collection = this.getCollectionPayload();
        await this.$store.dispatch('product/updateSettingData', {
          id: this.popularCollectionSettingId,
          data: JSON.stringify(collection)
        });
      } catch (error) {
        failedSections.push("Popular collections");
      }

      if (this.hasData(this.discountArr)) {
        try {
          await this.$store.dispatch('Accounts/discountUpdateNames', {disArr: this.discountArr});
        } catch (error) {
          failedSections.push("Discount Labels");
        }
      }

      if (this.hasData(this.profileTypeArr)) {
        try {
          await this.$store.dispatch('product/updateProfileType', {proTArr: this.profileTypeArr});
        } catch (error) {
          failedSections.push("Profile Type");
        }
      }

      if (this.hasData(this.colorFamilyArr)) {
        try {
          await this.$store.dispatch('product/updateColorFamily', {dataArr: this.colorFamilyArr});
        } catch (error) {
          failedSections.push("Color Family");
        }
      }

      if (this.hasData(this.thicknessArr)) {
        try {
          await this.$store.dispatch('product/updateThickness', {dataArr: this.thicknessArr});
        } catch (error) {
          failedSections.push("Thickness");
        }
      }

      if (this.hasData(this.dimensionsArr)) {
        try {
          await this.$store.dispatch('product/updateDimensions', {dataArr: this.dimensionsArr});
        } catch (error) {
          failedSections.push("Dimensions");
        }
      }

      if (this.hasData(this.styleArr)) {
        try {
          await this.$store.dispatch('product/setupStyle', {data: {dataArr: this.styleArr}, method: 'put'});
        } catch (error) {
          failedSections.push("Style");
        }
      }

      if (this.hasData(this.collectionPopular)) {
        try {
          await this.$store.dispatch('product/setupCollPop', {value_lines: this.collectionPopular});
        } catch (error) {
          failedSections.push("Popular Value Line");
        }
      }

      if (this.hasData(this.frametypeArr)) {
        try {
          await this.$store.dispatch('product/setupFrameType', {
            data: {types: this.frametypeArr},
            method: 'put'
          });
          await this.$store.dispatch('product/setupFrameType', {method: 'get'});
        } catch (error) {
          failedSections.push("Frame Types");
        }
      }

      loader.hide();
      if (failedSections.length > 0) {
        this.toast.error(`Some sections failed to save: ${failedSections.join(", ")}`);
        return;
      }
      this.toast.success("Saved");
    }
  },
  async mounted() {
    try {
      const settingsPromise = this.$store.dispatch('product/settingsData');
      await this.$store.dispatch('product/collectionData', {options: {perPage: 1000, orderCol: 'name', orderDir: 'Asc'}});
      const rez = await settingsPromise;
      const popularCollections = rez.find(obj => obj.name === "popular_collections");
      if (popularCollections) {
        this.popularCollectionSettingId = popularCollections.id;
      }
      if (popularCollections && popularCollections.data !== undefined) {
        let popcolObj = {};
        try {
          popcolObj = JSON.parse(popularCollections.data);
        } catch (error) {
          popcolObj = {};
        }
        this.collectionSpots = popcolObj;
      }
    } finally {
      this.isInitialLoading = false;
    }
  }
};
</script>
<style scoped>
.site-config-wrapper {
  position: relative;
}

.site-config-disabled {
  pointer-events: none;
  opacity: 0.65;
}

.site-config-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 50;
  background: rgba(27, 31, 35, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}


</style>